export default __webpack_public_path__ + "static/media/Pencil.cf92eccf.svg";